export const formatDisplayUserId = function(userId) {
  if (typeof userId !== 'string') return userId;
  if (userId.startsWith('AD')) return userId.replace(/^AD(?!M)/, 'ADM');
  if (userId.startsWith('SUB')) return userId.replace(/^SUB/, 'AD');
  if (userId.startsWith('M')) return userId.replace(/^M(?!A)/, 'MA');
  return userId;
};

export const reverseDisplayUserId = function(userId) {
  if (typeof userId !== 'string') return userId;
  if (userId.startsWith('ADM')) return userId.replace(/^ADM/, 'AD');
  if (userId.startsWith('AD')) return userId.replace(/^AD/, 'SUB');
  if (userId.startsWith('MA')) return userId.replace(/^MA/, 'M');
  return userId;
};
